// extracted by mini-css-extract-plugin
export var section = "splash--section--3qPfA";
export var section__wrapper = "splash--section__wrapper--1qyqe";
export var section__img = "splash--section__img--1Ttb6";
export var imageWrapper = "splash--image-wrapper--2bDmK";
export var section__body = "splash--section__body--3Cb5h";
export var buttons = "splash--buttons--1SBdS";
export var btn = "splash--btn--_sM9m";